export function scrollAnimations() {
  const onlineVal = document.querySelector('.servers__online-val');
  if (onlineVal) {
    const text = onlineVal.textContent.trim();
    const match = text.match(/(\d[\d\s]*)/);
    if (match) {
      const numberStr = match[1].replace(/\s/g, '');
      const targetNumber = parseInt(numberStr, 10);
      const suffix = text.replace(match[1], '').trim();
      let animated = false;

      const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animated) {
            animated = true;
            animateCounter(onlineVal, targetNumber, suffix, 2000);
            counterObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      onlineVal.textContent = `0 ${suffix}`;
      counterObserver.observe(onlineVal);
    }
  }

  const benefitsItems = document.querySelectorAll('.hero__benefits-item');
  benefitsItems.forEach((item, i) => {
    item.classList.add('benefit-reveal');
    item.style.transitionDelay = `${i * 0.15}s`;
  });

  const benefitsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const items = entry.target.querySelectorAll('.benefit-reveal');
        items.forEach((item) => item.classList.add('benefit-reveal--visible'));

        // Animate "10 000" counter in the first benefit
        const firstBenefitTitle = entry.target.querySelector('.hero__benefits-item:first-child .hero__benefits-item-text > span:first-child');
        if (firstBenefitTitle) {
          const plusSpan = firstBenefitTitle.querySelector('.hero__benefits-item-text-opacity');
          const fullText = firstBenefitTitle.textContent.trim();
          const numMatch = fullText.match(/(\d[\d\s]*)/);
          if (numMatch) {
            const num = parseInt(numMatch[1].replace(/\s/g, ''), 10);
            const hasPlus = plusSpan !== null;
            firstBenefitTitle.textContent = '0';
            if (hasPlus) {
              const newPlus = document.createElement('span');
              newPlus.className = 'hero__benefits-item-text-opacity';
              newPlus.textContent = '+';
              firstBenefitTitle.appendChild(newPlus);
            }
            animateCounterNode(firstBenefitTitle, num, hasPlus, 1500);
          }
        }

        benefitsObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  const benefitsList = document.querySelector('.hero__benefits-list');
  if (benefitsList) benefitsObserver.observe(benefitsList);

  const revealElements = document.querySelectorAll(
    '.hero__benefits-list, .details, .about, .reviews, .servers, .social, .news'
  );

  revealElements.forEach((el) => {
    el.classList.add('reveal');
  });

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal--visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  revealElements.forEach((el) => revealObserver.observe(el));
}

function animateCounter(element, target, suffix, duration) {
  const start = performance.now();
  const formatNumber = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
    const current = Math.round(eased * target);
    element.textContent = suffix ? `${formatNumber(current)} ${suffix}` : formatNumber(current);
    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

function animateCounterNode(element, target, hasPlus, duration) {
  const start = performance.now();
  const formatNumber = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
    const current = Math.round(eased * target);
    element.childNodes[0].textContent = formatNumber(current);
    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}
